
/**
 * 选择单个元素
 * @param {String} selector css 选择器
 * @param {Object} context 上下文，默认是 document
 */ function $667b4cf47f010a7c$export$3d8c2f653ac9d0b9(selector, context) {
    context = context || document;
    return context.querySelector(selector);
}
function $667b4cf47f010a7c$export$fe324b23443c13e2(selector, context) {
    context = context || document;
    return Array.prototype.slice.apply(context.querySelectorAll(selector));
}


const $0711ec730d151e1f$var$urlMap = {
    bcz: "https://www.baicizhan.com/",
    mint: "http://reading.baicizhan.com/",
    yequ: "https://np.baicizhan.com/"
};
(0, $667b4cf47f010a7c$export$fe324b23443c13e2)(".link-title").forEach((node)=>{
    const id = node.getAttribute("id");
    node.addEventListener("click", function() {
        window.location.href = $0711ec730d151e1f$var$urlMap[id];
    });
});


//# sourceMappingURL=index.d1035613.js.map
